import Vue from 'vue'

var pipeService = new Vue({
    data: {
        TESTEVENT: 'test_event',
        SELECTDATA: 'select_data',
        SELECTSUBSETDATA: 'select_subset_data',
        SELECTCLUSTER: 'select_cluster',
        SELECTRELATION: 'select_relation',
        SELECTCONCEPT: 'select_concept',
        SELECTIONONLYTRUEFALSE: 'select_only_true_false', 
        SELECTONLYQCHIT: 'select_only_qc_hit', 
        CURRENTINSPECTED: 'current_inspected',
        HOVERDATA: 'hover_data',
        HOVERCLUSTER: 'hover_cluster',
        SAVEINSTANCES: 'save_instances',
        OPENDRAWER: 'open_drawer'
    },
    methods: {
        emitTestEvent: function(msg) {
            this.$emit(this.TESTEVENT, msg)
        },
        onTestEvent: function(callback) {
            this.$on(this.TESTEVENT, function(msg) {
                callback(msg)
            })
        },
        emitOpenDrawer: function(msg){
            this.$emit(this.OPENDRAWER, msg)
        },
        onOpenDrawer: function(callback){
            this.$on(this.OPENDRAWER, function(msg){
                callback(msg);
            })
        },
        emitSaveInstances: function(msg){
            this.$emit(this.SAVEINSTANCES, msg)
        },
        onSaveInstances: function(callback){
            this.$on(this.SAVEINSTANCES, function(msg){
                callback(msg);
            })
        },
        emitSelectData: function(msg){
            this.$emit(this.SELECTDATA, msg)
        },
        onSelectData: function(callback){
            this.$on(this.SELECTDATA, function(msg){
                callback(msg);
            })
        },
        emitSelectCluster: function(msg){
            this.$emit(this.SELECTCLUSTER, msg)
        },
        onSelectCluster: function(callback){
            this.$on(this.SELECTCLUSTER, function(msg){
                callback(msg);
            })
        },
        emitSelectSubsetData: function(msg){
            this.$emit(this.SELECTSUBSETDATA, msg)
        },
        onSelectSubsetData: function(callback){
            this.$on(this.SELECTSUBSETDATA, function(msg){
                callback(msg);
            })
        },
        emitSelectConcept: function(msg){
            this.$emit(this.SELECTCONCEPT, msg)
        },
        onSelectConcept: function(callback){
            this.$on(this.SELECTCONCEPT, function(msg){
                callback(msg);
            })
        },
        emitSelectRelation: function(msg){
            this.$emit(this.SELECTRELATION, msg)
        },
        onSelectRelation: function(callback){
            this.$on(this.SELECTRELATION, function(msg){
                callback(msg);
            })
        },
        emitHoverData: function(msg){
            this.$emit(this.HOVERDATA, msg)
        },
        onHoverData: function(callback){
            this.$on(this.HOVERDATA, function(msg){
                callback(msg);
            })
        },
        emitHoverCluster: function(msg){
            this.$emit(this.HOVERCLUSTER, msg)
        },
        onHoverCluster: function(callback){
            this.$on(this.HOVERCLUSTER, function(msg){
                callback(msg);
            })
        },
        emitSelectOnlyTrueFalse: function(msg) {
            this.$emit(this.SELECTIONONLYTRUEFALSE, msg)
        },
        onSelectOnlyTrueFalse: function(callback) {
            this.$on(this.SELECTIONONLYTRUEFALSE, function(msg) {
                callback(msg);
            })
        },
        emitSelectOnlyQcHit: function(msg) {
            this.$emit(this.SELECTONLYQCHIT, msg)
        },
        onSelectOnlyQcHit: function(callback) {
            this.$on(this.SELECTONLYQCHIT, function(msg) {
                callback(msg);
            })
        },
        emitCurrentInspected: function(msg) {
            this.$emit(this.CURRENTINSPECTED, msg)
        },
        onCurrentInspected: function(callback) {
            this.$on(this.CURRENTINSPECTED, function(msg) {
                callback(msg);
            })
        },
    }
})
export default pipeService